<template>
  <div class="action-bar">
    <v-btn v-if="canReviewAiAnalysis" large depressed color="primary" class="action-btn" :loading="busy" :disabled="!pendingCount" @click="$emit('accept-all')">
      <v-icon left>mdi-check</v-icon>
      Accept all
    </v-btn>
    <v-btn v-if="canReviewAiAnalysis" large depressed color="error" class="action-btn" :loading="busy" :disabled="!pendingCount" @click="$emit('reject-all')">
      <v-icon left>mdi-close</v-icon>
      Reject all
    </v-btn>
    <!-- Disabled buttons swallow hover; the wrapping span carries the tooltip. -->
    <v-tooltip v-if="canReviewAiAnalysis" top>
      <template v-slot:activator="{ on, attrs }">
        <span class="action-bar__disabled" v-bind="attrs" v-on="on">
          <v-btn large outlined class="action-btn" disabled>
            <v-icon left>mdi-pencil-outline</v-icon>
            Edit findings
          </v-btn>
        </span>
      </template>
      <span>{{ editTooltip }}</span>
    </v-tooltip>
    <!-- `busy` covers the export too (AIAnalysisReport passes busy || exporting): the canvas render of a 20k px scan takes seconds. -->
    <v-btn large outlined class="action-btn" :loading="busy" :disabled="busy" @click="$emit('export')">
      <v-icon left>mdi-tray-arrow-down</v-icon>
      Export report (PDF)
    </v-btn>
  </div>
</template>

<script>
import aiAnalysisPermissionMixin from '@/features/Dashboard/utils/aiAnalysisPermissionMixin';
  import { EDIT_AREAS_TOOLTIP } from './reportConstants';

  export default {
    mixins: [aiAnalysisPermissionMixin],
    name: 'ReportActionBar',
    props: {
      pendingCount: { type: Number, default: 0 },
      busy: { type: Boolean, default: false },
    },
    data() {
      return { editTooltip: EDIT_AREAS_TOOLTIP };
    },
  };
</script>

<style lang="scss" scoped>
  .action-bar {
    position: sticky;
    bottom: 0;
    // Above the 360 viewer's navbar (z-index 90); see --z-action-bar in AIAnalysisReport.vue.
    z-index: var(--z-action-bar, 100);
    display: flex;
    align-items: center;
    gap: var(--ds-space-md);
    padding: var(--ds-space-md) 0 var(--ds-space-sm);
    background: var(--aa-page);
    box-shadow: 0 -1px 0 var(--aa-border-default);
    flex-wrap: wrap;
  }
  .action-btn { letter-spacing: 0.04em; }
  .action-bar__disabled { display: inline-flex; cursor: not-allowed; }

  @media (max-width: 760px) {
    .action-bar { position: static; }
    .action-btn { flex: 1 1 calc(50% - var(--ds-space-sm)); }
  }
</style>
